// стили для сетки и синей шапки
import './semanticUi'; // ставим первым, чтобы в main.scss перезаписать базовые свойства
import './legacy.scss';
import './fonts.css';
import './theme.css';
import 'intersection-observer';
import 'fullscreen-api-polyfill';
import '@vkontakte/vkui/dist/components.css';
import './arrayBufferPolyfill';

import config from 'Cloud/config';
import { sendAppReady } from 'lib/app-ready';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { APIConfig } from 'reactApp/api/APIConfig';
import { registerABExperiments } from 'reactApp/appHelpers/experiments';
import { hideHeadlineForDesktopR7 } from 'reactApp/hooks/useDesktopR7App';
import { initializeCloudAppCode } from 'reactApp/modules/start/CloudAppAdapterForReactPages';
import { initSaga, store } from 'reactApp/store';
import { App } from 'reactApp/ui/App/App';
import { initializeWebPush } from 'reactApp/modules/webPush/webPush';
import { initTracer } from 'reactApp/utils/tracer';
import { rootSaga } from 'rootSaga';
import { initSuperApp } from 'reactApp/utils/initSuperApp';
import { userKeeper } from '@mail-core/dashboard';

import { WorkspaceSuperappErrorPage } from './ui/WorkspaceSuperappErrorPage/WorkspaceSuperappErrorPage';
import { interceptDeeplinkSubscribe } from './utils/multiWindow';

(async () => {
    try {
        // Бизнес-метрика, не путать с biz-юзером
        userKeeper.time('biz-app-init');

        if (!(await initSuperApp())) {
            render(<WorkspaceSuperappErrorPage />, document.querySelector('#reactApp'));
            return;
        }

        initializeCloudAppCode();
        initSaga(rootSaga);
        initializeWebPush();
        registerABExperiments();
        initTracer();

        APIConfig.set('user', config.get('user.email'));
        APIConfig.set('csrf-token', config.get('tokens.csrf'));
        APIConfig.set('x-page-id', config.get('x-page-id'));
        APIConfig.set('auth-domain', config.get('AUTH_DOMAIN'));

        window.__store = store;

        document.body.classList.add('g-default-font');
        hideHeadlineForDesktopR7();

        if (/macintosh/i.test(navigator.userAgent)) {
            document.body.classList.add('g-macintosh-font');
        }

        interceptDeeplinkSubscribe();

        render(
            <Provider store={store}>
                <App />
            </Provider>,
            document.querySelector('#reactApp')
        );
    } catch (error) {
        sendAppReady(error);
    }
})();
